<template>
    <div id="career" v-if="careerData">
        <div class="career-banner" :style="'backgroundImage: url('+ careerData.career.career_img +');'"></div>
        <div class="career-main">
            <div class="career-nav">
                <div class="career-box">
                    <p class="title">{{ careerData.career.career_synopsis }} · 学习路径</p>
                    <p class="texts">{{ careerData.career.career_intro }}</p>
                    <ul class="nav-list">
                        <li>
                            <p><span>{{ careerData.item_count }}</span>大阶段 <span>{{ careerData.chapter_count }}</span>章节</p>
                            <p>路径内容</p>
                        </li>
                        <li>
                            <p><span>{{ careerData.total_playtime[0] }}</span>小时<span v-if="careerData.total_playtime[1] > 0">{{ careerData.total_playtime[1] }}分钟</span></p>
                            <p>视频时长</p>
                        </li>
                        <li>
                            <p><span>{{ formatCurrencyTenThou(careerData.total_play_count) }}</span>人</p>
                            <p>学习人数</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="career-route" v-if="careerData.career.career_show_marketing">
                <div class="route-list">
                    <div v-html="careerData.career.career_marketing"></div>
                </div>
            </div>

            <div class="career-content">
                <div v-for="(item,index) in careerData.career_items" :key="index" class="career-item">
                    <div class="career-module career-stage">
                        <div class="stage-felx">
                            <span :class="['stage-title',{'stage-w1': item.is_buy}]">{{ item.career_item_name }}</span>
                            <span v-if="!item.is_buy" class="stage-price" @click="careerBuy(item.career_item_aid)">单阶段 ￥{{ item.alum_price }}</span>
                        </div>
                        <p class="stage-text">{{ item.career_item_target }}</p>
                    </div>
                    <div class="career-module career-album">
                        <ul class="album-list">
                            <li v-for="(albumchp,num) in item.chapters" :key="num" :id="num" v-if="num < item.chapter_count">
                                <a :href="$commonVariable.yihu_href_url + '/a_'+ item.career_item_aid + '.html?career_video='+ albumchp.video_id" class="album-href">
                                    <img :src="albumchp.albumchp_cover_plan" onerror="this.src='https://www.yiihuu.com/assets/career/images/default.jpg';this.onerror=null;" class="album-img" alt=""/>
                                    <div class="album-box">
                                        <p class="album-title">{{ albumchp.albumchp_name }}</p>
                                        <p class="album-period">{{ albumchp.video_count }}课时 <span v-if="albumchp.video_playtime[0] || albumchp.video_playtime[1]">· <em v-if="albumchp.video_playtime[0]">{{ albumchp.video_playtime[0] }}小时</em><em v-if="albumchp.video_playtime[1]">{{ albumchp.video_playtime[1] }}分钟</em></span></p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div v-if="item.chapters.length > item.chapter_count" class="album-more"><span @click="getCareerChapter(index,item.chapters.length)">点击查看更多</span></div>
                    </div>
                </div>
            </div>

            <div class="career-recommend">
                <p class="recommend-title">/ 更多职业学习路径推荐 /</p>
                <ul class="recommend-list">
                    <li v-for="(item,index) in careerData.career_lists" :key="index">
                        <a :href="'/career/'+ item.career_id" class="recommend-href">
                            <div class="recommend-left">
                                <p class="title">{{ item.career_synopsis }}</p>
                                <p class="text">{{ item.career_intro }}</p>
                                <p class="stage">{{ item.career_item_count }}大阶段<i>·</i>{{ item.ablum_time[0] }}小时<i>·</i>{{ $teachFun(item.chapter_count) }}人在学</p>
                            </div>
                            <div class="recommend-right">
                                <img :src="item.career_img" alt=""/>
                            </div>
                        </a>
                    </li>
                </ul>
                <p class="recommend-tips">助你成就职业未来</p>
            </div>

            <div v-if="careerData.career.career_type == 1" class="career-purchase" >
                <div class="purchase-left">
                    <p class="purchase-price"><em>￥</em>{{ careerData.discount_price }}<span>￥{{ careerData.total_price }}</span></p>
                    <p class="purchase-discount">全路径套餐价<span>立省{{ parseFloat(careerData.total_price - careerData.discount_price).toFixed(2) }}元</span></p>
                </div>
                <div class="purchase-right">
                    <div class="purchase-consult" @click="consult53()">
                        <img src="@/assets/images/career/consult-icon.png" alt=""/>
                        <p>咨询</p>
                    </div>
                    <div class="purchase-button" v-if="careerData.career_buy_status != 1" @click="careerHref(careerUrl)">购买全路径</div>
                </div>
            </div>
            <div v-if="careerData.career.career_type == 2&&!isVip" class="career-purchase" >
                <div class="purchase-left">
                    <p class="purchase-price"><em>开通VIP 畅享路径视频</em></p>
                    <p class="purchase-discount">全路径套餐价<span>立省{{ parseFloat(careerData.discount_price).toFixed(2) }}元</span></p>
                </div>
                <div class="purchase-right">
                    <div class="purchase-consult" @click="consult53()">
                        <img src="@/assets/images/career/consult-icon.png" alt=""/>
                        <p>咨询</p>
                    </div>
                    <div class="purchase-button" v-if="careerData.career_buy_status != 1" @click="careerVipHref('/pay/wxpay1/buyvip_new.php?vip_type=15')">
                        购买VIP
                    </div>
                </div>
            </div>

            <div class="career-choice" v-if="choiceActive">
                <div class="careerLoad" v-if="loadIcon"><img src="@/assets/images/career/loading.gif" alt=""/></div>
                <template v-if="stageData">
                    <div class="career-pay wow fadeInUpH5" data-wow-delay="0.1s" data-wow-duration="0.1s">
                        <div class="choice-stage">
                            <div class="choice-top">
                                <p class="title">已选中{{ stagelength }}个阶段</p>
                                <p class="tips">选择满{{ stageNum[0] }}个阶段可享{{ stageNum[1] }}折</p>
                                <span class="choice-close" @click="stageChoice"></span>
                            </div>
                            <div class="choice-item">
                                <ul class="choice-list">
                                    <li v-for="(item,index) in careerIsBuy" :key="index" :class="{'on': item.stage_type}" v-if="!item.is_buy" @click="stageActive(index)">
                                        <div class="choice-box">
                                            <p class="choice-name">{{ item.career_item_name }}</p>
                                            <div class="choice-price">
                                                <p class="price-one">价格: <em><i>￥</i>{{ item.alum_price }}</em></p>
                                                <template v-if="item.stage_type">
                                                    <p class="price-two">{{ rebate }}</p>
                                                    <p class="price-three"><span>优惠价: <em><i>￥</i>{{ item.price_discount }}</em></span></p>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="stage-choice"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="choice-pay">
                            <div :class="['pay-all',{'active': payAll}]" @click="stageActive(0,1)">全选</div>
                            <div class="pay-flex">
                                <div class="pay-settle">
                                    <p class="total-price"><span>合计：</span><em>￥</em>{{ totalPrice }}</p>
                                    <p class="total-discount" v-if="stageData.cart.album_discount_rate != '1'">打折优惠：-￥{{ totalDiscount }}</p>
                                </div>
                                <div class="pay-button" @click="careerHref(stageUrl,1)">去结算({{ stagelength }})</div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

        </div>
    </div>
</template>

<script>
import { careerDetail as getCareerDetail } from '@/api/career/';
import { getUser } from '@/api/common/';
import { getToken } from '@/utils/auth'
export default {
    name: "Career",
    components: {},
    data() {
        return {
            careerId: this.$route.params.career_id,
            careerData: "",
            careerUrl: "",
            choiceActive: false,
            loadIcon: false,
            careerIsBuy: [],
            stageData: "",
            rebate: "",
            stageNum: [],
            stagelength: 0,
            totalPrice: 0,
            totalDiscount: 0,
            payAll: false,
            stageIds: [],
            stageUrl: "",
            apiHref: process.env.NODE_ENV == "production" ? process.env.VUE_APP_MYIHU_API : 'http://test.yiihuu.com:81',
            isLogin: this.$store.getters.token,
            isVip:0,
        };
    },
    created() {
        this.getUser();
    },
    mounted() {
        this.getCareerDetail();
    },
    methods: {
        async getCareerDetail(){
            let data = {
                tg: this.$CommonFun.getQueryString("TG") || this.$CommonFun.getQueryString("TJ"),
                url: window.location.href,
                career_id: this.careerId,
            }
            const res = await getCareerDetail(data)
            if (res.msg == "Success") {
                this.careerData = res.data;
                this.$nextTick(() => {
                    let allId = [];
                    let careerColor = this.careerData.career.career_color.split(",");
                    $(".career_box_tips>p").css("background-image", "linear-gradient(90deg, "+ careerColor[0] +" 0%, "+ careerColor[1] +" 100%)");
                    this.careerData.career_items.forEach((item,i)=>{
                        if(!item.is_buy){
                            this.careerIsBuy.push(item);
                            this.careerIsBuy.forEach((item,i)=>{
                                item["stage_type"] = 0;
                                item["price_discount"] = 0;
                            });
                            allId.push(item.career_item_aid);
                        }
                    });
                    this.careerUrl = allId.join("_");
                    this.$CommonFun.initWow();
                    this.$nodeAdd();
                });
            }
        },
        async getUser() {
            if (getToken()) {
                const res = await getUser();
                this.isVip = res.data.member.is_vip;
            }
        },
        getCareerChapter(index,number){
            this.careerData.career_items[index].chapter_count = number;
        },
        careerBuy(id){
            if(!this.isLogin){
                this.$layer.msg('请先登录');
                setTimeout(()=>{
                    window.location.href = process.env.VUE_APP_LOGIN_API + '/m_login.html?v=3&target_uri='+ location.href;
                }, 600);
                return false;
            }
            var indexNum = "";
            this.careerIsBuy.forEach((item,i)=>{
                if(id == item.career_item_aid){
                    indexNum = i;
                }
            });
            this.choiceActive = true;
            document.body.style.overflow = 'hidden';
            this.stageActive(indexNum);
        },
        stageActive(index,type){
            this.loadIcon = true;
            this.stageIds = [];
            this.stageUrl = "";
            if(type){
                this.payAll = this.payAll ? false : true;
                this.careerIsBuy.forEach((item,i)=>{
                    item.stage_type = this.payAll ? 1 : 0;
                    if(item.stage_type){
                        this.stageIds.push(item.career_item_aid);
                    }
                });
            }else{
                let count = 0;
                this.careerIsBuy[index].stage_type = this.careerIsBuy[index].stage_type ? 0 : 1;
                this.careerIsBuy.forEach((item,i)=>{
                    if(item.stage_type){
                        this.stageIds.push(item.career_item_aid);
                        count++;
                    }
                });
                this.careerIsBuy.length == count ? this.payAll = true : this.payAll = false;
            }
            this.stageUrl = this.stageIds.join("_");
            this.careerAjax(this.stageUrl);
        },
        careerAjax(api){
            let that = this;
            if(api){
                $.ajax({
                    url: that.apiHref + '/career/ajax.php?action=get_price&aids='+ api +'&career_id='+ this.careerId +'&hubi=0',
                    type: 'get',
                    dataType: "json",
                    success: function (res) {
                        if (res.error === "1") {
                            that.stageData = res.data;
                            let discountRate = /^\d+\.\d+$/.test(that.stageData.cart.album_discount_rate) ? parseFloat(that.stageData.cart.album_discount_rate) : parseInt(that.stageData.cart.album_discount_rate);
                            that.rebate = discountRate == 1 ? '无折扣' : (that.stageData.cart.album_discount_rate * 10) + '折';
                            that.stagelength = that.stageData.cart.item.length;
                            that.stageIf();
                            that.careerIsBuy.forEach((item,i)=>{
                                that.stageData.cart.item.forEach(data=>{
                                    if(item.career_item_aid == data.album_id){
                                        item["price_discount"] = data.album_price_discount;
                                    }
                                });
                            });
                            that.totalPrice = that.stageData.cart.total_price_discount;
                            that.totalDiscount = parseFloat(that.stageData.cart.total_price - that.totalPrice).toFixed(2);
                        } else {
                            that.$layer.msg(res.msg);
                        }
                        that.loadIcon = false;
                    }
                });
            }else{
                this.careerIsBuy.forEach((item,i)=>{
                    item["stage_type"] = 0;
                    item["price_discount"] = 0;
                });
                this.stagelength = 0;
                this.totalPrice = 0;
                this.totalDiscount = 0;
                this.stageIf();
                this.loadIcon = false;
            }
        },
        stageIf(){
            let stafeLength = this.careerData.career.career_discount_arr.length;
            for(let i = 0;i < stafeLength;i++){
                if(this.stagelength < this.careerData.career.career_discount_arr[i][0]){
                    this.stageNum = this.careerData.career.career_discount_arr[i];
                    return false;
                }else if(this.stagelength > this.careerData.career.career_discount_arr[stafeLength - 1][0]){
                    this.stageNum = this.careerData.career.career_discount_arr[stafeLength - 1];
                    return false;
                }
            }
        },
        stageChoice(){
            this.choiceActive = false;
            this.stageData = "";
            this.stageNum = [];
            this.stageUrl = "";
            this.payAll = false;
            this.careerIsBuy.forEach((item,i)=>{
                item.stage_type = 0;
            });
            document.body.style.overflow = '';
        },
        careerVipHref(url,type){
            if(!this.isLogin){
                this.$layer.msg('请先登录');
                setTimeout(()=>{
                    window.location.href = process.env.VUE_APP_LOGIN_API + '/m_login.html?v=3&target_uri='+ location.href;
                }, 600);
                return false;
            }else{
                window.location.href = this.$commonVariable.yihu_href_url + url;
            }
        },
        careerHref(url,type){
            if(!this.isLogin){
                this.$layer.msg('请先登录');
                setTimeout(()=>{
                    window.location.href = process.env.VUE_APP_LOGIN_API + '/m_login.html?v=3&target_uri='+ location.href;
                }, 600);
                return false;
            }else{
                if(type && this.stagelength <= 0){
                    this.$layer.msg('您还没有选择阶段哦');
                    return false;
                }
                window.location.href = this.$commonVariable.yihu_href_url + '/pay/wxpay1/career_buy.php?params='+ url + '&career_id=' + this.careerId;
            }
        },
        consult53(){
            $('div[53kf_icon_versions="1.0"]').trigger('click');
        },
        formatCurrencyTenThou(num) {
            num = num.toString().replace(/\$|\,/g, '');
            if (isNaN(num)) num = "0";
            let sign = (num == (num = Math.abs(num)));
            num = Math.floor(num * 10 + 0.50000000001);
            num = Math.floor(num / 10).toString();
            for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
                num = num.substring(0, num.length - (4 * i + 3)) + ',' +
                    num.substring(num.length - (4 * i + 3));
            return (((sign) ? '' : '-') + num);
        }
    }
}
</script>

<style lang="scss" scoped>
    .career-banner{
        width: 100%;
        height: 520px;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .career-main{
        width: 100%;
        padding: 0 33px 170px;
        position: relative;
        box-sizing: border-box;
        z-index: 9;
        .career-nav{
            width: 100%;
            height: 360px;
            position: relative;
            margin-top: -190px;
            &::before{
                content: "";
                width: 718px;
                height: 406px;
                background: url("~@/assets/images/career/career_nav.png") no-repeat;
                background-size: cover;
                position: absolute;
                top: -29px;
                left: 50%;
                transform: translateX(-50%);
            }
            .career-box{
                width: 100%;
                padding: 30px;
                position: relative;
                text-align: center;
                box-sizing: border-box;
                .title{
                    width: 100%;
                    height: 36px;
                    line-height: 36px;
                    font-size: 36px;
                    color: #333333;
                    font-weight: bold;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-bottom: 20px;
                }
                .texts{
                    width: 100%;
                    height: 144px;
                    line-height: 36px;
                    font-size: 24px;
                    color: #666666;
                    text-align: justify;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                    overflow: hidden;
                    margin-bottom: 40px;
                }
                .nav-list{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    li{
                        width: 208px;
                        padding: 4px 0 2px;
                        position: relative;
                        &:not(:last-child)::before{
                            content: "";
                            height: 100%;
                            border-left: 1px solid #ff9605;
                            position: absolute;
                            top: 0;
                            right: 0;
                        }
                        p{
                            width: 100%;
                            &:nth-child(1){
                                height: 24px;
                                font-size: 20px;
                                color: #333333;
                                font-weight: bold;
                                white-space: nowrap;
                                vertical-align: bottom;
                                span{
                                    height: 100%;
                                    line-height: 26px;
                                    font-size: 28px;
                                    display: inline-block;
                                    vertical-align: top;
                                }
                            }
                            &:nth-child(2){
                                line-height: 20px;
                                font-size: 20px;
                                color: #9d9d9d;
                                margin-top: 10px;
                            }
                        }
                    }
                }
            }
        }
        .career-route{
            width: calc(100% + 66px);
            height: 284px;
            margin-top: 40px;
            margin-left: -33px;
            overflow: hidden;
            box-sizing: border-box;
            .route-list{
                height: 304px;
                padding: 20px 0;
                overflow-x: scroll;
                overflow-y: hidden;
                white-space: nowrap;
                box-sizing: border-box;
                &::-webkit-scrollbar{
                    display: none;
                }
                ::v-deep .career_box{
                    .career_title{
                        display: none;
                    }
                    .career_box_list{
                        .career_box_tips{
                            width: 270px;
                            height: 244px;
                            background-color: #ffffff;
                            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
                            border-radius: 15px;
                            position: relative;
                            display: inline-block;
                            vertical-align: top;
                            &:nth-child(1){
                                margin-left: 33px;
                            }
                            &:last-child{
                                margin-right: 33px;
                            }
                            &:not(:last-child){
                                margin-right: 40px;
                                &::after{
                                    content: "";
                                    width: 10px;
                                    height: 20px;
                                    background: url("~@/assets/images/career/arrow.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    right: -25px;
                                    margin-top: -10px;
                                }
                            }
                            &>p{
                                width: 100%;
                                height: 60px;
                                line-height: 60px;
                                font-size: 24px;
                                color: #ffffff;
                                font-weight: bold;
                                text-align: center;
                                border-radius: 15px 15px 0 0;
                            }
                            .career_box_uli{
                                width: 100%;
                                height: 184px;
                                padding: 20px;
                                box-sizing: border-box;
                                li{
                                    width: 100%;
                                    line-height: 24px;
                                    font-size: 22px;
                                    color: #404040;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    padding-left: 20px;
                                    position: relative;
                                    box-sizing: border-box;
                                    &:not(:last-child){
                                        margin-bottom: 12px;
                                    }
                                    &::before{
                                        content: "";
                                        width: 10px;
                                        height: 10px;
                                        background-color: #ff9605;
                                        border-radius: 50%;
                                        position: absolute;
                                        top: 50%;
                                        left: 0;
                                        transform: translateY(-50%);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .career-content{
            width: 100%;
            margin-top: 40px;
            .career-item{
                width: 100%;
                &:not(:last-child){
                    margin-bottom: 60px;
                }
                .career-module{
                    width: 100%;
                    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
                    border-radius: 15px;
                    box-sizing: border-box;
                    &.career-stage{
                        background-color: #fffaf2;
                        padding: 20px 30px 14px;
                        .stage-felx{
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            span{
                                height: 64px;
                                line-height: 64px;
                                font-weight: bold;
                                display: inline-block;
                                &.stage-title{
                                    width: 370px;
                                    font-size: 28px;
                                    color: #ff8400;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    &.stage-w1{
                                        width: 100%;
                                    }
                                }
                                &.stage-price{
                                    width: 220px;
                                    font-size: 26px;
                                    color: #ffffff;
                                    white-space: nowrap;
                                    text-align: center;
                                    background-color: #ff9500;
                                    border-radius: 10px;
                                    cursor: pointer;
                                }
                            }
                        }
                        .stage-text{
                            width: 100%;
                            height: 102px;
                            line-height: 34px;
                            font-size: 22px;
                            color: #666666;
                            text-align: justify;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                            overflow: hidden;
                            padding-top: 14px;
                            border-top: 1px solid rgba(255, 149, 0, 0.1);
                            margin-top: 16px;
                            box-sizing: unset;
                        }
                    }
                    &.career-album{
                        background-color: #ffffff;
                        padding: 30px 26px 30px 54px;
                        margin-top: 30px;
                        .album-list{
                            width: 100%;
                            position: relative;
                            &::before,
                            &::after{
                                content: "";
                                position: absolute;
                            }
                            &::before{
                                height: calc(100% - 26px);
                                border-left: 2px dashed rgba(255,153,0,0.5);
                                top: 26px;
                                left: -29px;
                                z-index: 7;
                            }
                            &::after{
                                width: 26px;
                                height: 26px;
                                background: url("~@/assets/images/career/route-icon.png") no-repeat;
                                background-size: 100% 100%;
                                top: 0;
                                left: -40px;
                                z-index: 8;
                            }
                            li{
                                width: 100%;
                                &:not(:last-child){
                                    margin-bottom: 36px;
                                }
                                .album-href{
                                    width: 100%;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    .album-img{
                                        width: 280px;
                                        height: 160px;
                                        border-radius: 10px;
                                        float: left;
                                    }
                                    .album-box{
                                        width: 304px;
                                        position: relative;
                                        padding: 16px 0 12px;
                                        float: right;
                                        box-sizing: border-box;
                                        p{
                                            width: 100%;
                                            text-align: justify;
                                            &.album-title{
                                                height: 72px;
                                                line-height: 36px;
                                                font-size: 26px;
                                                color: #404040;
                                                display: -webkit-box;
                                                -webkit-box-orient: vertical;
                                                -webkit-line-clamp: 2;
                                                overflow: hidden;
                                            }
                                            &.album-period{
                                                line-height: 22px;
                                                font-size: 22px;
                                                color: #9d9d9d;
                                                margin-top: 40px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .album-more{
                            width: 100%;
                            height: 22px;
                            text-align: center;
                            margin-top: 50px;
                            span{
                                height: 100%;
                                line-height: 22px;
                                font-size: 22px;
                                color: #9d9d9d;
                                padding-right: 30px;
                                position: relative;
                                display: inline-block;
                                vertical-align: top;
                                cursor: pointer;
                                &::before{
                                    content: "";
                                    width: 20px;
                                    height: 20px;
                                    background: url("~@/assets/images/career/more-icon.png") no-repeat;
                                    background-size: 100% 100%;
                                    position: absolute;
                                    top: 50%;
                                    right: 0;
                                    margin-top: -10px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .career-recommend{
            width: 100%;
            margin-top: 70px;
            .recommend-title{
                width: 100%;
                line-height: 36px;
                font-size: 36px;
                color: #333333;
                font-weight: bold;
                text-align: center;
            }
            .recommend-list{
                width: 100%;
                margin: 50px 0;
                li{
                    width: 100%;
                    background-color: #ffffff;
                    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
                    border-radius: 15px;
                    &:not(:last-child){
                        margin-bottom: 40px;
                    }
                    .recommend-href{
                        width: 100%;
                        padding: 30px 20px 30px 30px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        box-sizing: border-box;
                        .recommend-left{
                            width: 310px;
                            position: relative;
                            &::after{
                                content: "";
                                width: 40px;
                                height: 4px;
                                background-color: #ff9500;
                                border-radius: 2px;
                                position: absolute;
                                top: 48px;
                                left: 0;
                            }
                            .title{
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                font-size: 30px;
                                color: #404040;
                                font-weight: bold;
                                text-align: justify;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                overflow: hidden;
                            }
                            .text{
                                width: 100%;
                                height: 108px;
                                line-height: 36px;
                                font-size: 24px;
                                color: #666666;
                                text-align: justify;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                overflow: hidden;
                                margin: 33px 0;
                            }
                            .stage{
                                width: 100%;
                                line-height: 20px;
                                font-size: 20px;
                                color: #9d9d9d;
                                white-space: nowrap;
                                i{
                                    margin: 0 2px;
                                }
                            }
                        }
                        .recommend-right{
                            width: 294px;
                            padding-bottom: 22px;
                            position: relative;
                            &::before{
                                content: "";
                                width: 268px;
                                height: 198px;
                                background: url("~@/assets/images/career/career_shading.png") no-repeat;
                                background-size: cover;
                                position: absolute;
                                left: 50%;
                                bottom: 0;
                                transform: translateX(-50%);
                            }
                            img{
                                width: 100%;
                                height: 202px;
                                border-radius: 10px;
                                position: relative;
                                display: block;
                                z-index: 8;
                            }
                        }
                    }
                }
            }
            .recommend-tips{
                width: 100%;
                line-height: 22px;
                font-size: 22px;
                color: #9d9d9d;
                text-align: center;
                position: relative;
                &::before,
                &::after{
                    content: "";
                    width: 224px;
                    border-top: 1px solid #cccccc;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                }
                &::before{
                    left: 0;
                }
                &::after{
                    right: 0;
                }
            }
        }
        .career-purchase{
            width: 100%;
            height: 120px;
            background-color: #ffffff;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
            padding: 18px 20px 26px 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: fixed;
            bottom: 0;
            left: 0;
            box-sizing: border-box;
            z-index: 99;
            .purchase-left{
                height: 100%;
                float: left;
                .purchase-price{
                    height: 38px;
                    line-height: 38px;
                    font-size: 46px;
                    color: #ff6e0d;
                    font-weight: bold;
                    em,span{
                        display: inline-block;
                        vertical-align: bottom;
                    }
                    em{
                        height: 30px;
                        line-height: 30px;
                        font-size: 30px;
                        font-weight: bold;
                    }
                    span{
                        height: 28px;
                        line-height: 28px;
                        font-size: 28px;
                        color: #666666;
                        font-weight: normal;
                        text-decoration: line-through;
                        margin-left: 10px;
                    }
                }
                .purchase-discount{
                    height: 24px;
                    line-height: 26px;
                    font-size: 22px;
                    color: #ff6e0d;
                    margin-top: 14px;
                    span{
                        height: 100%;
                        line-height: 22px;
                        font-size: 16px;
                        border: 1px solid #ff6e0d;
                        border-radius: 4px;
                        padding: 0 6px;
                        margin-left: 10px;
                        display: inline-block;
                        vertical-align: top;
                        box-sizing: border-box;
                    }
                }
            }
            .purchase-right{
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                float: right;
                .purchase-consult{
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    img{
                        width: 37px;
                        height: 35px;
                        display: block;
                    }
                    p{
                        line-height: 24px;
                        font-size: 24px;
                        color: #888888;
                        margin-top: 7px;
                    }
                }
                .purchase-button{
                    width: 260px;
                    height: 100%;
                    line-height: 76px;
                    font-size: 30px;
                    color: #ffffff;
                    font-weight: bold;
                    letter-spacing: 1px;
                    text-align: center;
                    background-image: linear-gradient(90deg, #ffab28 0%, #ff9000 100%);
                    border-radius: 38px;
                    margin-left: 30px;
                    cursor: pointer;
                }
            }
        }
        .career-choice{
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            position: fixed;
            top: 0;
            left: 0;
            z-index: 999;
            .careerLoad{
                width: 60px;
                height: 60px;
                background-color: rgba(0,0,0,0.5);
                border-radius: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                z-index: 1000000;
                img{
                    width: 32px;
                    height: 32px;
                    display: block;
                }
            }
            .career-pay{
                width: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                .choice-stage{
                    width: 100%;
                    background-color: #fafafa;
                    border-radius: 30px 30px 0px 0px;
                    position: relative;
                    overflow: hidden;
                    .choice-top{
                        width: 100%;
                        text-align: center;
                        background-color: #ffffff;
                        padding: 30px 0 20px;
                        position: relative;
                        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
                        .title{
                            line-height: 28px;
                            font-size: 28px;
                            color: #404040;
                            font-weight: bold;
                        }
                        .tips{
                            line-height: 24px;
                            font-size: 24px;
                            color: #9d9d9d;
                            margin-top: 8px;
                        }
                        .choice-close{
                            width: 24px;
                            height: 24px;
                            background: url("~@/assets/images/career/close-icon.png") no-repeat;
                            background-size: 100% 100%;
                            position: absolute;
                            top: 50%;
                            right: 30px;
                            margin-top: -12px;
                            cursor: pointer;
                        }
                    }
                    .choice-item{
                        width: 100%;
                        max-height: 770px;
                        overflow: hidden;
                        .choice-list{
                            width: 100%;
                            max-height: inherit;
                            padding: 30px 30px 140px;
                            overflow-y: scroll;
                            overflow-x: hidden;
                            box-sizing: border-box;
                            li{
                                width: 100%;
                                background: url("~@/assets/images/career/stage-icon.jpg") no-repeat;
                                background-size: 100% 100%;
                                box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
                                border-radius: 10px;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding: 30px 30px 20px 42px;
                                box-sizing: border-box;
                                &.on{
                                    .stage-choice::before{
                                        background: url("~@/assets/images/career/choiceOn-icon.png") no-repeat;
                                        background-size: 100% 100%;
                                    }
                                }
                                &:not(:last-child){
                                    margin-bottom: 20px;
                                }
                                .choice-box{
                                    width: 562px;
                                    .choice-name{
                                        width: 100%;
                                        line-height: 28px;
                                        font-size: 28px;
                                        color: #404040;
                                        font-weight: bold;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                    .choice-price{
                                        width: 100%;
                                        height: 30px;
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                        margin-top: 12px;
                                        p{
                                            height: 100%;
                                            line-height: 30px;
                                            font-size: 22px;
                                            color: #ff6e0d;
                                            em{
                                                font-weight: bold;
                                                font-size: 26px;
                                                display: inline-block;
                                                i{
                                                    font-size: 22px;
                                                    font-style: normal;
                                                    display: inline-block;
                                                    vertical-align: text-bottom;
                                                }
                                            }
                                            &.price-two{
                                                width: 76px;
                                                text-align: center;
                                                background-color: #fffaf2;
                                                border-radius: 15px;
                                            }
                                            &.price-three{
                                                width: 230px;
                                                span{
                                                    max-width: 100%;
                                                    height: 100%;
                                                    line-height: 30px;
                                                    white-space: nowrap;
                                                    background-color: #fffaf2;
                                                    border-radius: 15px;
                                                    padding: 0 20px;
                                                    display: inline-block;
                                                    vertical-align: top;
                                                    box-sizing: border-box;
                                                }
                                            }
                                        }
                                    }
                                }
                                .stage-choice{
                                    height: 28px;
                                    line-height: 28px;
                                    font-size: 24px;
                                    padding-left: 40px;
                                    position: relative;
                                    cursor: pointer;
                                    &::before{
                                        content: "";
                                        width: 28px;
                                        height: 28px;
                                        background: url("~@/assets/images/career/choice-icon.png") no-repeat;
                                        background-size: 100% 100%;
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                    }
                                }
                            }
                        }
                    }
                }
                .choice-pay{
                    width: 100%;
                    height: 120px;
                    background-color: #ffffff;
                    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 22px 30px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    box-sizing: border-box;
                    .pay-all{
                        height: 28px;
                        line-height: 28px;
                        font-size: 24px;
                        padding-left: 40px;
                        position: relative;
                        cursor: pointer;
                        &::before{
                            content: "";
                            width: 28px;
                            height: 28px;
                            background: url("~@/assets/images/career/choice-icon.png") no-repeat;
                            background-size: 100% 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                        &.active::before{
                            background: url("~@/assets/images/career/choiceOn-icon.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                    .pay-flex{
                        height: 76px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        .pay-settle{
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: flex-end;
                            margin-right: 20px;
                            .total-price{
                                height: 30px;
                                line-height: 30px;
                                font-size: 38px;
                                color: #ff6e0d;
                                font-weight: bold;
                                span,em{
                                    line-height: 24px;
                                    font-size: 24px;
                                    display: inline-block;
                                    vertical-align: bottom;
                                }
                                span{
                                    color: #404040;
                                }
                            }
                            .total-discount{
                                line-height: 20px;
                                font-size: 20px;
                                color: #ff6e0d;
                                margin-top: 12px;
                            }
                        }
                        .pay-button{
                            width: 220px;
                            height: 100%;
                            line-height: 76px;
                            font-size: 30px;
                            color: #ffffff;
                            font-weight: bold;
                            letter-spacing: 1px;
                            text-align: center;
                            background-image: linear-gradient(90deg, #ffab28 0%, #ff9000 100%);
                            border-radius: 38px;
                            display: block;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>
<style scoped>
    .fadeInUpH5{
        animation: fadeInUpH5 0.1s ease 0.3s 1 normal both running;
        -webkit-animation: fadeInUpH5 0.1s ease 0.3s 1 normal both running;
        -moz-animation: fadeInUpH5 0.1s ease 0.3s 1 normal both running;
        -ms-animation: fadeInUpH5 0.1s ease 0.3s 1 normal both running;
        -o-animation: fadeInUpH5 0.1s ease 0.3s 1 normal both running;
    }
    @keyframes fadeInUpH5{
        0% {
            opacity: 0;
            -webkit-transform: translate3d(0,150px,0);
            transform: translate3d(0,150px,0);
        }
        100% {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }
    @-webkit-keyframes fadeInUpH5{
        0% {
            opacity: 0;
            -webkit-transform: translate3d(0,150px,0);
            transform: translate3d(0,150px,0);
        }
        100% {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }
</style>
